//@ts-ignore
// @ts-nocheck
const subjectKeywordGroup = {
  "Further Math": [
    "further",
    "futher",
    "additional",
    "statistics",
    "calculus",
    "differentiation",
    "integration",
  ],
  "SSS Math": [
    "calculations",
    "calculation",
    "calculate",
    "mathematical",
    "mathematics",
    "mth",
    "math",
    "maths",
    "mathematic",
  ],
  Physics: ["physics", "waves", "motion"],
  Chemistry: ["chemistry", "chemical", "stoichometry", "organic", "inorganic"],
  Biology: ["biology", "biological", "genetics"],
  "SSS English": [
    "english",
    "idioms",
    "idiom",
    "comprehension",
    "summary",
    "summaries",
    "letter",
    "read",
    "write",
    "essay",
    "essays",
  ],
  Literature: ["prose", "literature"],
  Economics: ["economics"],
  Accounting: ["account", "accounting", "bookkeeping"],
  Government: ["government"],
  "JSS Math": [
    "calculations",
    "calculation",
    "calculate",
    "arithmetic",
    "mathematical",
    "mathematics",
    "geometry",
    "trigonometry",
    "mth",
    "math",
    "maths",
    "mathematic",
  ],
  "JSS English": [
    "english",
    "comprehension",
    "essay",
    "essays",
    "summary",
    "summaries",
    "read",
    "reads",
    "readng",
    "reading",
    "write",
    "written",
    "writing",
    "writting",
  ],
  "Primary Math": [
    "calculations",
    "calculation",
    "calculate",
    "arithmetic",
    "mathematical",
    "mathematics",
    "mth",
    "math",
    "maths",
    "mathematic",
    "quantitative",
  ],
  "Primary English": [
    "tense",
    "tenses",
    "english",
    "verbal",
    "read",
    "reads",
    "readng",
    "reading",
    "write",
    "written",
    "writing",
    "writting",
    "comprehension",
    "spelling",
    "spellings",
    "spell",
    "spells",
  ],
  "Literacy & Numeracy": [
    "literacy",
    "numeracy",
    "foundation",
    "figures",
    "colouring",
    "count",
    "counting",
    "number",
    "numeric",
    "numbers",
    "vocabulary",
  ],
  "Creative Writing": [
    "creative",
    "composition",
    "stories",
    "narrative",
    "essays",
    "essay",
    "writing",
    "writting",
  ],
  Phonics: [
    "read",
    "reads",
    "readng",
    "reading",
    "speech",
    "speak",
    "spoken",
    "speaking",
    "spell",
    "spelling",
    "spellings",
    "diction",
    "queen",
    "queens",
    "queen's",
    "phonics",
    "phonetics",
    "write",
    "written",
    "writing",
    "writting",
    "pronounce",
    "pronunciation",
    "pronounciation",
    "oral",
    "blend",
    "blending",
  ],
  Handwriting: [
    "handwriting",
    "presentation",
    "presentations",
    "cursive",
    "legibly",
    "legible",
    "nelson",
  ],
};

let sampleExpectation = "My son has problems with calculation";

const sampleSubjectGroup = [
  "Primary English",
  "Handwriting",
  "JSS English",
  "Primary Math",
];

/*
  Disregard keyword if it has any negating prefices and suffixes
  e.g "My son can read well"
  => "read" is not taken into account
  */
const negatingPrefix = ["can"];
const negatingSuffix = ["okay"];

function getSubjectFromExpectation(
  clientExpectation = sampleExpectation,
  subjectGroup = sampleSubjectGroup,
) {
  //Splits expectation at spaces and commas
  let splitExpectation = clientExpectation.split(/[ ,]+/);

  /*
    Gets an array of the object keys 
    i.e. ["Further Math", "SSS Math",...]
    */
  let subjectArray = Object.keys(subjectKeywordGroup);

  /*
    Compares lowercased splitted words with keywords in each subjectKeywordGroup and
    filters only to those that appear in both arrays removing full stop and
    commas at the end of each word, while discounting keywords with negating prefices and suffixes
    */
  let foundKeywords = Object.values(subjectKeywordGroup).map(
    (subjectKeywords) =>
      splitExpectation.filter(
        (word, index) =>
          subjectKeywords.includes(word.replace(/[.,\s]/g, "").toLowerCase()) &&
          !negatingPrefix.includes(splitExpectation[index - 1]) &&
          !negatingSuffix.includes(splitExpectation[index + 1]),
      ),
  );

  //Counts number of times each keyword appears in client's expectation
  let keywordCount = foundKeywords.map((keywords) => keywords.length);

  /*
    Matches keyword to the subject keys and filters 
    to only those subjects selected by client (subjectGroup)
    */
  let selectedKeywords = keywordCount.filter((count, index) =>
    subjectGroup.includes(subjectArray[index]),
  );

  /*
    Gets the index of the selectedKeyword that appears the most number of times
    and also matches to a subject that was selected by client (subjectGroup)
    */
  if (selectedKeywords.filter(Boolean).length > 0) {
    let subjectIndex = keywordCount.findIndex(
      (element, index) =>
        subjectGroup.includes(subjectArray[index]) &&
        element === Math.max(...selectedKeywords),
    );

    //Returns first element in subjectGroup if no keyword was found
    return subjectIndex > -1 ? subjectArray[subjectIndex] : subjectGroup[0];
  }
  return subjectGroup[0];
}

export default getSubjectFromExpectation;
